import { tv, type VariantProps } from 'tailwind-variants'

import { dataFocusVisibleClasses } from '@/src/styles/classes'

export const avatar = tv({
  slots: {
    base: [
      'flex',
      'relative',
      'justify-center',
      'items-center',
      'web:box-border',
      'overflow-hidden',
      'align-middle',
      'rounded-full',
      'text-white',
      'z-0',
      ...dataFocusVisibleClasses,
    ],
    img: ['flex', 'w-full', 'h-full'],
    fallback: ['flex', 'items-center', 'justify-center'],
    icon: ['flex', 'items-center', 'justify-center', 'self-center'],
  },
  variants: {
    size: {
      xs: {
        base: 'h-8 w-8',
      },
      sm: {
        base: 'h-10 w-10',
      },
      md: {
        base: 'h-12 w-12',
      },
      lg: {
        base: 'h-14 w-14',
      },
      xl: {
        base: 'h-20 w-20',
      },
      '2xl': {
        base: 'h-32 w-32',
      },
      '3xl': {
        base: 'h-40 w-40',
      },
      '4xl': {
        base: 'h-44 w-44',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export type TAvatarVariantProps = VariantProps<typeof avatar>
export type TAvatarSlots = keyof ReturnType<typeof avatar>
